import React from 'react';
import "./terms.css"

const Terms = () => {
    return (
        <div className="termsAndConditions fadeIn">
            <h1 className="termsAndConditionsHeading">Terms & Conditions</h1>

            <h4 className="spangleWelcome">Introduction</h4>
            <p className="termsParagraphIntro">
                These Terms and Conditions (“Terms”) govern your access to and use of the services provided by Red Wolf InfoTech (“Company”), effective from March 2026. By accessing or using the Company’s services, you agree to comply with and be legally bound by these Terms. If
you do not agree with any part of these Terms, you must refrain from using our services.
            </p>

            <div className="serviceLeadingSection">
                <h4><span className="sn blue">1.</span><span className="st blue">Jurisdiction and Governing Law</span></h4>
                <p className="spl">
                    These Terms shall be governed by and interpreted in accordance with the laws of Uttar Pradesh, India. Any disputes arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts
located in Uttar Pradesh, India.
                </p>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Contact Information</h6>
                    <p className="serviceDetails">
                        Company Name: Red Wolf Info Tech Pvt. Ltd.<br />
                        Address: Assotech Business Cresterra, 214 Tower-4, 2nd Floor, Sector-135, Noida, Uttar Pradesh, India – 201305<br />
                        Email: info@redwolfinfotech.com
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Limitation of Liability and Disclaimer of Warranties</h6>
                    <p className="serviceDetails">
                        The Company provides its services on an “as is” and “as available” basis. We do not guarantee that the services will be uninterrupted, secure, or free from errors. Your use of our services is at your own risk. The Company shall not be held liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of our services.
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Rules of Conduct</h6>
                    <p className="serviceDetails">
                        By using our services, you agree to comply with all applicable laws, regulations, and these Terms. You are responsible for ensuring that your use of the services remains lawful and appropriate at all times.
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">User Restrictions</h6>
                    <p className="serviceDetails">
                        Users must be at least 18 years of age to access and use our services. By using the services, you confirm that you meet this age requirement.
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">User Guidelines and Acceptable Uses</h6>
                    <p className="serviceDetails">
                        Users are expected to use our services responsibly, ethically, and in full compliance with these Terms and all applicable laws.
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Prohibited Behaviors and Activities</h6>
                    <p className="serviceDetails">
                            The following actions are strictly prohibited while using our services:<br />
                             1. Engaging in harassment, discrimination, abuse, or hate speech of any kind.<br />
                             2. Uploading, transmitting, or distributing content that is unlawful, obscene, defamatory, or offensive.<br />
                             3. Attempting to interfere with, disrupt, or compromise the security or integrity of our services.<br />
                             4. Impersonating any individual or entity, or falsely representing your affiliation with any person or organization.<br />
                             5. Participating in fraudulent, deceptive, or misleading activities.<br/>
                             6. Violation of these provisions may result in suspension or termination of access to our services and may lead to legal action where applicable.
                    </p>
                    <div className="secionLine lineColorBlue"></div>
                </div>
            </div>

            <div className="serviceLeadingSection">
                <h4><span className="sn orange">2.</span><span className="st orange">User Contributions Clause</span></h4>
                <p className="spl">
                    By submitting, posting, or sharing any content with the Company, you grant us a perpetual, irrevocable, worldwide, royalty- free, and non-exclusive license to use, reproduce, modify, publish, distribute, and display such content in connection withour services. You represent and warrant that you own or have the necessary rights to submit such content and that it does not violate any third-party rights or applicable laws.
                </p>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Digital Millennium Copyright Act (DMCA)</h6>
                    <p className="serviceDetails">
                        The Company respects the intellectual property rights of others and expects users to do the same.
                    </p>
                    <div className="secionLine lineColorOrange"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Intellectual Property Disclosure</h6>
                    <p className="serviceDetails">
                        All intellectual property rights related to the Company’s services, including but not limited to trademarks, logos, content, software, designs, and other materials, are owned by the Company or its licensors. No part of the services may be copied, reproduced, distributed, or used without prior written permission from the Company.
                    </p>
                    <div className="secionLine lineColorOrange"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Dispute Resolutions Clause</h6>
                    <p className="serviceDetails">
                        Any disputes, claims, or controversies arising out of or relating to these Terms shall be resolved through arbitration in
                        accordance with the provisions of the Arbitration and Conciliation Act, 1996. The decision of the arbitrator shall be final and binding on the parties.
                    </p>
                    <div className="secionLine lineColorOrange"></div>
                </div>
            </div>

            <div className="serviceLeadingSection">
                <h4><span className="sn lightGreen">3.</span><span className="st lightGreen"> Services & Products Provided by the Company:</span></h4>
                <p className="spl">
                    <strong>The Company offers the following services and products:</strong> 
                </p>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Finance Locker:</h6>
                    <p className="serviceDetails">
                        Providing secure and innovative digital financial storage solutions designed for safety, convenience, and easy access.
                    </p>
                    <div className="secionLine lineColorGreen"></div>
                </div>



                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Red Wolf EV:</h6>
                    <p className="serviceDetails">
                        Delivering advanced electric vehicles engineered to revolutionize urban mobility with efficiency, sustainibility, and modern design.
                    </p>
                    <div className="secionLine lineColorGreen"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Red Wolf LED TV:</h6>
                    <p className="serviceDetails">
                        Providing high-definition picture quality, smart connectivity features, and immersive sound to enhace the home
                        entertainment experience.
                    </p>
                    <div className="secionLine lineColorGreen"></div>
                </div>

                <div className="serviceInfoContainer">
                    <h6 className="serviceLead">Red Wolf Nationx Mobile Accessories:</h6>
                    <p className="serviceDetails">
                        Offering premium mobile accessories designed for durability, performance, and everyday convenience.
                    </p>
                    <div className="secionLine lineColorGreen"></div>
                </div>
            </div>

            <div className="serviceLeadingSection">
                <p className="spl">
                    These Terms and Conditions constitute the entire agreement between the Company and its users regarding the use of our services.
                </p>
            </div>

{/* 

            <div className="serviceInfoContainer">
                <h1 className="termsAndConditionsHeading">Terms & Conditions For Speaker</h1>
                <h6 className="serviceLead"></h6>
                <p className="serviceDetails">
                    WARRANTY SERVICE TYPE - For Any Warranty Related Issues,
                    <br />
                    Please Call The Red Wolf Customer Support - +91-9988908111 & support@redwolfinfotech.com
                    <br />
                    WARRANTY - 6 Months
                    <br />
                    No Warranty In Classic and Brass Model
                    <br />
                    COVERED IN WARRANTY - Manufacturing Defects
                    <br />
                    NOT COVERED IN WARRANTY - Physical Damages
                    <br />
                    ALL ABOVE MENTIONED PRICES ARE INCLUDING GST.
                </p>
                <div className="secionLine lineColorBlue"></div>
            </div>


            <div className="serviceInfoContainer">
                <h1 className="termsAndConditionsHeading">Terms & Conditions For LED TV's</h1>
                <h6 className="serviceLead"></h6>
                <p className="serviceDetails">
                    WARRANTY SERVICE TYPE - For Any Warranty Related Issues,
                    <br />
                    Please Call The Red Wolf Customer Support - +91-9988908111 & support@redwolfinfotech.com
                    <br />
                    WARRANTY - 1 Year
                    <br />
                    COVERED IN WARRANTY - Manufacturing Defects
                    <br />
                    NOT COVERED IN WARRANTY - Physical Damages
                    <br />
                    ALL ABOVE MENTIONED PRICES ARE INCLUDING GST.
                </p>
                <div className="secionLine lineColorBlue"></div>
            </div> */}
            {/* <h4 className="closeTerms">
                <a href="/index.html">CLOSE TERMS AND CONDITIONS</a>
            </h4> */}
        </div>
    );
};

export default Terms;